import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';

export const OR_STATUS_ACTIVE = 'ACTIVE';
export const OR_STATUS_ON_HOLD = 'ON_HOLD';
export const OR_STATUS_NOT_SUBSCRIBED = 'NOT_SUBSCRIBED';
export const OR_STATUS_FAILED_PAYMENT = 'FAILED_PAYMENT';

const OR_SUBSCRIPTION_URL = `${config.apiBasePath}/slotsub/subscription`;

export const OR_REQUEST_SUBSCRIPTION = 'OR_REQUEST_SUBSCRIPTION';
export const OR_RECEIVE_SUBSCRIPTION = 'OR_RECEIVE_SUBSCRIPTION';
export const OR_RECEIVE_SUBSCRIPTION_ERROR = 'OR_RECEIVE_SUBSCRIPTION_ERROR';

export function requestORSubscription() {
  return {
    type: OR_REQUEST_SUBSCRIPTION,
  };
}

export function receiveORSubscription(data) {
  return {
    type: OR_RECEIVE_SUBSCRIPTION,
    data,
  };
}

export function receiveORSubscriptionError({ error }) {
  return {
    type: OR_RECEIVE_SUBSCRIPTION_ERROR,
    error,
  };
}
export function getORSubscription() {
  return (dispatch, getState, { network }) => {
    dispatch(requestORSubscription());
    return network.get(OR_SUBSCRIPTION_URL)
      .then((data) => {
        if (data.status === OR_STATUS_NOT_SUBSCRIBED) {
          network.redirectTo({ to: '/or-signup' });
        }
        dispatch(receiveORSubscription(data));
      })
      .catch(err => {
        dispatch(receiveORSubscriptionError(err.data || UNKNOWN_ERROR));
      });
  };
}
